import React from 'react'
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material'

const CanFilterDropDown= ({
    label,
    name,
    value,
    changeHandler,
    width=false,
    error=false,
    helperText=false,
    className=''
}) => {
    
  return (
    <FormControl 
        sx={{ width: { xs: '100%', sm:width === false ? '30%':'100%',  md:width === false ? '24%':'100%'}}} 
        margin="dense"
        className={className}
    >
        <InputLabel id="demo-simple-select-standard-label">{label}</InputLabel>
        <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            sx={{ "&:focus": {
                backgroundColor: "#ffffff"
                } 
            }}
            label={label} 
            value={value === 'Yes' ? 1 : value === 'No' ? 0 : value === 0 ? 0 : value || ""}
            onChange={changeHandler}
            name={name}
            error={error && value === ""}
        >
            <MenuItem value="">Select Persistent</MenuItem>
            <MenuItem value={1}>Yes</MenuItem>
            <MenuItem value={0}>No</MenuItem>
        </Select>
        <FormHelperText sx={{color:"#d32f2f"}} >{helperText && value === "" ? "Required Field!" : false}</FormHelperText>
    </FormControl>
  )
}

export default CanFilterDropDown